/* =============================================================================
   TUCHMASKENDEAL – Discount-Bridge fuer BSS B2B (v2, COOP-sicher)
   JET CEUTICALS – Theme "Kopie von jcs-shop/main Trade Angebot"
   -----------------------------------------------------------------------------
   WICHTIG:
   Diese Version fasst die Checkout-Navigation NICHT mehr an. Das Abfangen von
   fetch/XHR/window.open/location hatte den Shopify-Checkout (/checkouts/do/...)
   mit NS_ERROR_DOM_COOP_FAILED zerschossen (Cross-Origin-Opener-Policy).

   Ansatz jetzt: Der Code wird – genau wie ueber das native Rabattfeld des
   Themes – per POST /cart/update.js auf den WARENKORB gelegt. BSS baut die
   Draft-Order aus diesem Warenkorb, der Code reist als Cart-Discount mit.
   Gilt nur bei erfuelltem A/B-Warenkorb (window.TuchmaskenLock); wird der
   Warenkorb ungueltig, entfernt das Skript den Code wieder.

   Falls BSS den Cart-Discount NICHT in die Draft-Order uebernimmt, richtet
   dieses Skript keinen Schaden an (Checkout laeuft normal) – dann brauchen wir
   den serverseitigen Weg (Webhook draft_orders/create).
   ============================================================================= */
(function () {
  'use strict';

  var CODE = 'TUCHMASKENDEAL';
  var CART_UPDATE = (window.Theme && Theme.routes && Theme.routes.cart_update_url) || '/cart/update.js';
  var busy = false;

  function isValid() {
    try { return !window.TuchmaskenLock || window.TuchmaskenLock.isValid(); }
    catch (e) { return true; }
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Aktuell auf den Warenkorb angewendete Rabattcodes (nur Code-basierte)
  function existingCodes(cart) {
    var out = [];
    var apps = (cart && cart.cart_level_discount_applications) || [];
    apps.forEach(function (a) {
      if (a && a.title && (a.type === 'discount_code' || a.type == null)) out.push(a.title);
    });
    // Fallback fuer aeltere Cart-Payloads
    if (cart && Array.isArray(cart.discount_codes)) {
      cart.discount_codes.forEach(function (d) {
        if (d && d.code && d.applicable !== false && out.indexOf(d.code) === -1) out.push(d.code);
      });
    }
    return out;
  }

  function hasCode(list) {
    return list.some(function (c) { return c.toUpperCase() === CODE.toUpperCase(); });
  }

  // Rabattliste auf den Warenkorb schreiben (leer = alle entfernen)
  function setDiscounts(list) {
    return fetch(CART_UPDATE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: list.join(',') })
    }).then(function (r) { return r.json(); });
  }

  function notifyThemeRefreshed() {
    ['cart:refresh', 'cart:updated'].forEach(function (ev) {
      try { document.dispatchEvent(new CustomEvent(ev)); } catch (e) {}
    });
  }

  /* ---- Info-Box ueber dem Checkout-Button ein-/ausblenden --------------- */
  // Nur sichtbar, wenn der Warenkorb die A/B-Deal-Regel erfuellt.
  window.__tuchmaskenDealValid = window.__tuchmaskenDealValid || false;

  function applyInfoVisibility() {
    var boxes = document.querySelectorAll('.js-tuchmasken-info');
    for (var i = 0; i < boxes.length; i++) {
      if (window.__tuchmaskenDealValid) boxes[i].removeAttribute('hidden');
      else boxes[i].setAttribute('hidden', '');
    }
  }
  // Nach Section-Re-Renders (Menge/Rabatt) wird die Box neu gezeichnet -> nachziehen
  setInterval(applyInfoVisibility, 1500);

  // Code per Klick kopieren
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.js-tuchmasken-copy');
    if (!btn) return;
    e.preventDefault();
    function feedback() {
      btn.textContent = 'Kopiert';
      setTimeout(function () { btn.textContent = CODE; }, 1200);
    }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(CODE).then(feedback).catch(feedback);
      } else {
        var ta = document.createElement('textarea');
        ta.value = CODE; ta.setAttribute('readonly', '');
        ta.style.position = 'absolute'; ta.style.left = '-9999px';
        document.body.appendChild(ta); ta.select();
        document.execCommand('copy'); document.body.removeChild(ta);
        feedback();
      }
    } catch (err) {}
  });

  // Kernabgleich: gueltig -> Code sicherstellen; ungueltig -> Code entfernen
  function reconcile() {
    if (busy) return;
    busy = true;
    getCart()
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) {
          window.__tuchmaskenDealValid = false; applyInfoVisibility(); busy = false; return;
        }
        var codes = existingCodes(cart);
        var present = hasCode(codes);
        // Frische A/B-Pruefung direkt auf dem gerade geladenen Warenkorb
        var want = window.TuchmaskenLock && window.TuchmaskenLock.isValidCart
          ? window.TuchmaskenLock.isValidCart(cart)
          : isValid();
        window.__tuchmaskenDealValid = want;
        applyInfoVisibility();

        if (want && !present) {
          var next = codes.concat([CODE]);
          return setDiscounts(next).then(function () { notifyThemeRefreshed(); });
        }
        if (!want && present) {
          var reduced = codes.filter(function (c) { return c.toUpperCase() !== CODE.toUpperCase(); });
          return setDiscounts(reduced).then(function () { notifyThemeRefreshed(); });
        }
        // schon korrekt -> nichts tun (keine Endlosschleife)
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  // Nach Warenkorb-Mutationen (add/change/update/clear) neu abgleichen.
  // Der eigene POST /cart/update.js loest zwar auch aus, endet aber sofort,
  // weil der Zustand dann bereits korrekt ist.
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      var url = typeof arguments[0] === 'string' ? arguments[0]
        : (arguments[0] && arguments[0].url) || '';
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/(add|change|clear)/.test(url)) {
        p.then(function (r) { if (r && r.ok) setTimeout(reconcile, 200); }).catch(function () {});
      }
      return p;
    };
  }

  ['cart:refresh', 'cart:updated', 'cart:build', 'cart-drawer:open']
    .forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(reconcile, 200); }); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(reconcile, 300); });
  } else {
    setTimeout(reconcile, 300);
  }
})();
